import LoginPage from './LoginPage';
import RegistrationPage from './RegistrationPage';
import NotAuthorized from './components/NotAuthorized';
import i18n from '@/plugins/i18n.js';

export default [
  {
    path: '/login/:verificationToken?',
    name: 'login',
    component: LoginPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.login'),
      bypassOrgCheck: true,
      requiresAuth: false,
      hideSidebar: true,
      customHeader: true,
      fullScreen: true,
      allowMobile: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegistrationPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.register'),
      bypassOrgCheck: true,
      requiresAuth: false,
      hideSidebar: true,
      customHeader: true,
      fullScreen: true,
      allowMobile: true
    }
  },
  {
    path: '/auth/401',
    name: 'notAuthorized',
    props: false,
    component: NotAuthorized,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.401NotAuthorized'),
      bypassOrgCheck: true,
      requiresAuth: false,
      hideSidebar: true
    }
  },
  {
    path: '/auth/reset-password/:resetEmail/:resetToken',
    name: 'resetPassword',
    props: true,
    component: LoginPage,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.resetPassword'),
      bypassOrgCheck: true,
      requiresAuth: false,
      hideSidebar: true,
      customHeader: true,
      fullScreen: true,
      allowMobile: true
    }
  },
  {
    path: '/auth/verify/:verificationToken',
    name: 'verifyEmail',
    redirect: to => {
      const { verificationToken } = to.params;
      return `/login/${verificationToken}`;
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/auth/verify-and-reset-password/:resetEmail/:resetToken',
    name: 'verifyAndResetPassword',
    props: true,
    component: LoginPage,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.activateAccountAndSetPassword'),
      bypassOrgCheck: true,
      requiresAuth: false,
      hideSidebar: true,
      customHeader: true,
      fullScreen: true,
      verifyAccount: true,
      allowMobile: true
    }
  }
];
